import { Address } from '@guardfinder/address';

import { Observable } from 'rxjs';

import { UnitResult } from '../../../error/Domain/unit-result';

/**
 * IsGuardsAvailableService
 *
 * Abstract service that defines the contract for checking guard availability at a location.
 *
 * Responsibilities:
 * - Verifies if guards are available at a specific address.
 * - Returns the availability status as a UnitResult containing a boolean.
 *
 * Usage:
 * - Used by components like LeadFormComponent to check if guards are available
 *   at a user's address before proceeding with lead or job creation.
 *
 * @see BackendGuardsAvailableService for the concrete implementation.
 */
export abstract class IsGuardsAvailableService {
    /**
     * Checks if guards are available at the specified address.
     *
     * @param clientLead The address to check for guard availability.
     * @returns An Observable of UnitResult<boolean> where:
     *          - true indicates guards are available at the location
     *          - false indicates no guards are available
     *          - UnitResult.failure indicates an error occurred during the check
     */
    abstract execute(clientLead: Address): Observable<UnitResult<boolean>>;
}
